const bowser = require('bowser');
/* eslint-disable */
/**
 * PCUtil
 */
class PCVideoutil {
    showTextMenu(e) {
        // 自定义右键菜单样式
        const clickX = e.clientX;

        const clickY = e.clientY;
        const videoMenu = document.getElementById('js_video_menu');

        videoMenu.style.display = 'block';
        videoMenu.style.left = `${clickX - videoboxLeft}px`; // eslint-disable-line
        videoMenu.style.top = `${clickY - this.getEleOffsetTop(box)}px`; // eslint-disable-line
        e.stopPropagation();
        e.preventDefault();
    }
    hideTextMenu() {
        // 隐藏右键后的自定义菜单
        const videoMenu = document.getElementById('js_video_menu');

        videoMenu.style.display = 'none';
    }
    hasClass(ele, classname) {
        // 检测某个元素是否含有该类名
        return ele.className.indexOf(classname);
    }
    removeClass(ele, classname) {
        // 移除类名
        if (this.hasClass(ele, classname) > -1) {
            const reg = new RegExp(`(\\s|^)${classname}(\\s|$)`);

            ele.className = ele.className.replace(reg, ' ');
        }
    }
    addClass(ele, classname) {
        // 添加类名
        if (this.hasClass(ele, classname) < 0) {
            ele.className += ` ${classname}`;
        }
    }
    getStyle(ele) {
        // 获取元素现在的sytle
        const cur = ele.currentStyle ? ele.currentStyle : document.defaultView.getComputedStyle(ele, null);

        return cur;
    }
    delNodes(ele) {
        // 获取后代，删除无用node
        const ele_child = ele.childNodes;

        for (let i = 0; i < ele_child.length; i++) {
            if (ele_child[i].nodeName === '#text' && !/\s/.test(ele_child.nodeValue)) {
                ele.removeChild(ele_child[i]);
            }
        }

        return ele;
    }
    removeElement(...args) {
        // 删除元素
        for (let i = 0, ilen = args.length; i < ilen; i++) {
            const _parentElement = args[i].parentNode;

            if (_parentElement) _parentElement.removeChild(args[i]);
        }
    }
    moretime(time) {
        const seconds = Math.round(time % 60) < 10 ? `0${Math.round(time % 60)}` : Math.round(time % 60);
        const minutes = parseInt((time / 60) % 60) < 10 ? `0${parseInt((time / 60) % 60)}` : parseInt((time / 60) % 60);
        const hours = parseInt((time / 3600) % 24);
        const goodhours = hours < 10 ? `0${hours}` : hours;

        if (hours === 0) {
            return `${minutes}:${seconds}`;
        } else {
            return `${goodhours}:${minutes}:${seconds}`;
        }
    }
    formatTime(_time) {
        // 格式化时间
        let second = _time / 1;

        const temp = [];

        let s = 0;

        if (second === 0) {
            return '00:00';
        }
        while (second !== 0) {
            s = second % 60;
            if (s < 10) {
                s = `0${s}`;
            }
            temp.unshift(s);
            second = Math.floor(second / 60);
        }
        if (temp.length < 2) {
            temp.unshift('00');
        }

        return temp.join(':');
    }
    formatNum(num) {
        // 格式化数字
        let _num = num;

        if (num < 100) {
            if (num < 10) {
                _num = `00${num}`;
            } else {
                _num = `0${num}`;
            }
        }

        return _num;
    }
    getEleOffsetLeft(obj) {
        // 获取元素相对于浏览器窗口最左边的距离
        let l = obj.offsetLeft;

        while (obj.offsetParent != null) {
            obj = obj.offsetParent;
            l += obj.offsetLeft;
        }

        return l;
    }
    getEleOffsetTop(obj) {
        // 获取元素相对于浏览器窗口最顶部的距离
        let l = obj.offsetTop;

        while (obj.offsetParent != null) {
            obj = obj.offsetParent;
            l += obj.offsetTop;
        }

        return l;
    }
    bind(ele, type, fn) {
        // 给元素绑定相应事件
        if (typeof type === 'string') {
            if (ele.addEventListener) {
                ele.addEventListener(type, fn, false);
            } else if (ele.attachEvent) {
                ele.attachEvent(`on${type}`, fn);
            } else {
                ele[`on${type}`] = fn;
            }
        } else {
            for (const i in type) {
                if (ele.addEventListener) {
                    ele.addEventListener(type, fn, false);
                } else if (ele.attachEvent) {
                    ele.attachEvent(`on${type[i]}`, fn);
                } else {
                    ele[`on${type[i]}`] = fn;
                }
            }
        }
    }
    removeHandler(element, type, handler) {
        if (element.removeEventListener) {
            element.removeEventListener(type, handler, false);
        } else if (element.detachEvent) {
            element.detachEvent(`on${type}`, handler);
        } else {
            element[`on${type}`] = null;
        }
    }
    extend() {
        const result = {};

        for (let i = 0, iLen = arguments.length; i < iLen; i++) {
            const o = arguments[i]; // eslint-disable-line

            for (const key in o) {
                result[key] = o[key];
            }
        }

        return result;
    }
    playerSetCookie(name, value, path, domain, expires, secure) {
        // 设置cookie
        const doFn = encodeURIComponent;
        const cStrArr = [];

        cStrArr.push(`${name}=${doFn(value)}`);
        if (expires) {
            const date = new Date();

            date.setTime(date.getTime() + expires * 1000 * 60);
            cStrArr.push(`; expires=${date.toGMTString()}`);
        }
        cStrArr.push(path ? `; path=${path}` : '');
        cStrArr.push(domain ? `; domain=${domain}` : '');
        cStrArr.push(secure ? '; secure' : '');
        document.cookie = cStrArr.join('');
    }
    playerGetAll() {
        const cookieArr = [];

        if (document.cookie !== '') {
            const cStrArr = document.cookie.split(';');

            for (let i = 0, l = cStrArr.length; i < l; i++) {
                const cStr = cStrArr[i];
                const index = cStr.indexOf('=');
                const name = cStr.substring(0, index).replace(/[ ]/g, '');
                const value = cStr.substring(index + 1);
                const cookie = {};

                cookie.name = name;
                cookie.value = value;
                cookieArr.push(cookie);
            }
        }

        return cookieArr;
    }
    playerGetCookie(name) {
        // 获取cookie
        const cookieArr = this.playerGetAll();

        for (let i = 0, l = cookieArr.length; i < l; i++) {
            const cookie = cookieArr[i];

            if (cookie.name === name) {
                const doFn = decodeURIComponent;

                return doFn(cookie.value);
            }
        }

        return '';
    }
    showFlashPlayer() {
        // 显示flash播放器，隐藏video播放器，用于两者间的转换
        document.getElementById('playercontainer').style.display = 'none';
        document.getElementById('vPlayer_box').style.display = 'block';
        document.getElementById('playercontainer').parentNode.removeChild(document.getElementById('playercontainer'));
    }
    ifIE() {
        // 判断是否为ie浏览器
        const ieFlag = !!(!!window.ActiveXObject || 'ActiveXObject' in window);

        return ieFlag;
    }
    ifFlash() {
        // 判断是否为flash播放器，用于flash和video的切换
        const flashFlag = this.playerGetCookie('ifFlag');

        return flashFlag;
    }
    getOS() {
        const sUserAgent = navigator.userAgent;

        const _platform = navigator.platform;

        const isWin = _platform === 'Win32' || _platform === 'Windows';

        const isMac = _platform === 'Mac68K' || _platform === 'MacPPC' || _platform === 'Macintosh' || _platform === 'MacIntel';

        if (isMac) return 'Mac';
        const isUnix = _platform === 'X11' && !isWin && !isMac;

        if (isUnix) return 'Unix';
        const isLinux = String(_platform).indexOf('Linux') > -1;

        if (isLinux) return 'Linux';
        if (isWin) {
            const isWin2K = sUserAgent.indexOf('Windows') > -1 || sUserAgent.indexOf('Windows 2000') > -1;

            if (isWin2K) return 'Win2000';
            const isWinXP = sUserAgent.indexOf('Windows NT 5.1') > -1 || sUserAgent.indexOf('Windows XP') > -1;

            if (isWinXP) return 'WinXP';
            const isWin2003 = sUserAgent.indexOf('Windows NT 5.2') > -1 || sUserAgent.indexOf('Windows 2003') > -1;

            if (isWin2003) return 'Win2003';
            const isWinVista = sUserAgent.indexOf('Windows NT 6.0') > -1 || sUserAgent.indexOf('Windows Vista') > -1;

            if (isWinVista) return 'WinVista';
            const isWin7 = sUserAgent.indexOf('Windows NT 6.1') > -1 || sUserAgent.indexOf('Windows 7') > -1;

            if (isWin7) return 'Win7';
        }

        return 'other';
    }
    getBrowser() {
        const browser = bowser.getParser(window.navigator.userAgent);
        const browserInfo = browser.getBrowser();

        return {
            type: browserInfo.name || '',
            version: browserInfo.version || ''
        };
        // const explorer = window.navigator.userAgent.toLowerCase();
        // let ver = '';

        // if (explorer.indexOf('msie') >= 0) {
        //     // ie
        //     ver = (explorer.match(/msie ([\d.]+)/) && explorer.match(/msie ([\d.]+)/)[1]) || 'unknown';

        //     return {
        //         type: 'IE',
        //         version: ver,
        //     };
        // } else if (explorer.indexOf('firefox') >= 0) {
        //     // firefox
        //     ver = (explorer.match(/firefox\/([\d.]+)/) && explorer.match(/firefox\/([\d.]+)/)[1]) || 'unknown';

        //     return {
        //         type: 'Firefox',
        //         version: ver,
        //     };
        // } else if (explorer.indexOf('chrome') >= 0) {
        //     // chrome
        //     ver = (explorer.match(/chrome\/([\d.]+)/) && explorer.match(/chrome\/([\d.]+)/)[1]) || 'unknown';

        //     return {
        //         type: 'Chrome',
        //         version: ver,
        //     };
        // } else if (explorer.indexOf('opera') >= 0) {
        //     // opera
        //     ver = (explorer.match(/opera.([\d.]+)/) && explorer.match(/opera.([\d.]+)/)[1]) || 'unknown';

        //     return {
        //         type: 'Opera',
        //         version: ver,
        //     };
        // } else if (explorer.indexOf('safari') >= 0) {
        //     // safari
        //     ver = (explorer.match(/version\/([\d.]+)/) && explorer.match(/version\/([\d.]+)/)[1]) || 'unknown';

        //     return {
        //         type: 'Safari',
        //         version: ver,
        //     };
        // } else {
        //     return {
        //         type: '',
        //         version: ver, // eslint-disable-line
        //     };
        // }
    }
    getResolution() {
        return {
            screenW: screen.width,
            screenH: screen.height
        };
    }
    getCookie(name) {
        const cStrArr = document.cookie.split(';');

        for (let i = 0, l = cStrArr.length; i < l; i++) {
            const cStr = cStrArr[i];
            const index = cStr.indexOf('=');
            const cname = cStr.substring(0, index).replace(/[ ]/g, '');
            const value = cStr.substring(index + 1);

            if (cname === name) {
                return decodeURIComponent(value);
            }
        }

        return '';
    }

    setCookie(name, value) {
        const cStrArr = [];

        cStrArr.push(`${name}=${encodeURIComponent(value)}`);
        const date = new Date();

        date.setTime(date.getTime() + 24 * 60 * 1000 * 60 * 7);
        cStrArr.push(`; expires=${date.toGMTString()}`);
        cStrArr.push('; path=/');
        cStrArr.push('; domain=.ifeng.com');

        document.cookie = cStrArr.join('');
    }
    getRandomUid() {
        const date = new Date().getTime();

        let uid = '';

        let fn = '';

        let sn = '';

        fn = ((Math.random() * 2147483648) | 0).toString(36);
        sn = Math.round(Math.random() * 10000);
        uid = `${date}_${fn}${sn}`;

        return uid;
    }
    getCurrentViedoInfo() {
        const result = videoinfo; // eslint-disable-line
        const o = {};

        o.img = encodeURIComponent(result.videoLargePoster);
        o.title = encodeURIComponent(result.name);
        o.url = encodeURIComponent(result.url);
        o.guid = result.guid;

        return o;
    }
    shareVideo(sTag, type) {
        const info = this.getCurrentViedoInfo();
        const _tp = new Date().getTime();
        let url = '';
        let appkey = '';
        let site = '';

        switch (sTag) {
            case 'sinateew':
                // 这个请求是405。。
                // ifeng.util.getScript('//api.t.sina.com.cn/friendships/create/1806128454.xml?source=168486312');
                url = `//v.t.sina.com.cn/share/share.php?appkey=168486312&url=${info.url}${encodeURIComponent(`?tp=${_tp}#_share=sina`)}&title=${
                    info.title
                }&source=ifeng&sourceUrl=//v.ifeng.com/&content=utf8&ralateUid=1806128454&pic=${info.img}`;

                window.open(
                    url,
                    '',
                    `toolbar=0,status=0,resizable=1,width=440,height=430,left=
                     ${(screen.width - 440) / 2},top=
                     ${(screen.height - 430) / 2}`
                );
                break;

            case 'qqzone':
                window.open(`//sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=${info.url}${encodeURIComponent(`?tp=${_tp}#_share=qqZone`)}`);
                break;

            case 'qqteew':
                appkey = encodeURIComponent('f8ca1cd768da4529ab190fae9f1bf21d');
                site = '//v.ifeng.com';
                // //connect.qq.com/widget/shareqq/index.html?title=&url=&desc=&pics=&site=&callback=?userId=0
                // //connect.qq.com/intro/sharetoqq/index.html?title='实拍台军拒统利器宣传片 毫不避讳台独姿态'&url=/v.ifeng.com/test/wx_test.shtml&desc=按发送方师傅上发生地方&pics=&site=ddd
                url = `//connect.qq.com/widget/shareqq/index.html?title=${info.title}&url=${info.url}${encodeURIComponent(
                    `?tp=${_tp}#_share=qq`
                )}&appkey=${appkey}&site=${site}&pic=${info.img}`;
                window.open(url);
                break;
            case 'renren':
                url = `//share.renren.com/share/buttonshare.do?link=${info.url}${encodeURIComponent(`?tp=${_tp}#_share=${type}`)}&title=${info.title}`;
                window.open(url);
                break;

            case 'ifengteew':
                url = `//t.ifeng.com/interface.php?_c=share&_a=share&sourceUrl='}${info.url}${encodeURIComponent(`?tp=${_tp}#_share=${type}`)}&title=${info.title}&pic=${
                    info.img
                }&source=${encodeURIComponent('凤凰视频')}&type=1`;
                window.open(
                    url,
                    '',
                    `toolbar=0,status=0,resizable=1,width=640,height=481,left=
                     ${(screen.width - 440) / 2},top=
                     ${(screen.height - 480) / 2}`
                );

                break;

            case 'kaixin':
                url = `//www.kaixin001.com/repaste/share.php?rurl=${info.url}${encodeURIComponent(`?tp=${_tp}#_share=${type}`)}&rtitle=${info.title}`;
                window.open(url);
                break;

            case 'sohuteew':
                url = `//t.sohu.com/third/post.jsp?url=${info.url}${encodeURIComponent(`?tp=${_tp}#_share=${type}`)}&title=${info.title}&content=utf-8&pic=${info.img}`;
                window.open(
                    url,
                    '',
                    `toolbar=0,status=0,resizable=1,width=660,height=470,left=
                     ${(screen.width - 660) / 2},top=
                     ${(screen.height - 470) / 2}`
                );
                break;

            case '163':
                url = `//t.163.com/article/user/checkLogin.do?link=//www.ifeng.com&source=${encodeURIComponent('凤凰网')}&info=${info.title}${info.url}${encodeURIComponent(
                    `?tp=${_tp}#_share=${type}`
                )}&${new Date().getTime()}`;
                window.open(
                    url,
                    '',
                    `height=330,width=550,toolbar=no,menubar=no,scrollbars=no,resizable=yes,location=no,status=no,top=
                     ${(screen.height - 280) / 2},left=
                     ${(screen.width - 550) / 2}`
                );
                break;

            case 'feixin':
                url = `//space.fetion.com.cn/api/share?Source=${encodeURIComponent('凤凰视频')}&Title=${info.title}&url=${info.url}${encodeURIComponent(
                    `?tp=${_tp}#_share=${type}`
                )}&IsEditTitle=false`;
                window.open(url);
                break;

            // 对网址有验证，所以内网地址通不过
            case '51com':
                url = `//share.51.com/share/out_share_video.php?from=${encodeURIComponent('凤凰视频')}&title=${info.title}&vaddr=${info.url}${encodeURIComponent(
                    `?tp=${_tp}#_share=${type}`
                )}&IsEditTitle=false&charset=utf-8`;
                window.open(url);
                break;

            // 对网址有验证，所以内网地址通不过
            case 'baiduI':
                url = `//tieba.baidu.com/i/app/open_share_api?link=${info.url}${encodeURIComponent(`?tp=${_tp}#_share=${type}`)}`;
                window.open(url);
                break;

            case 'weixin':
                url = `//v.ifeng.com/weixin.shtml?title=${info.title}&link=${info.url}`;
                window.open(
                    url,
                    '分享到微信',
                    `height=984,width=850,toolbar=no,menubar=no,scrollbars=no,resizable=yes,location=no,status=no,top=
                     ${(screen.height - 280) / 2},left=
                     ${(screen.width - 550) / 2}`
                );
                break;

            default:
                break;
        }
    }
    sendStatisticInfoC(type) {
        const statistic = {};

        statistic.datatype = 'share';
        statistic.value = type;

        let userid = null;

        let info = '';

        if (this.getCookie('userid') === '') {
            userid = this.getRandomUid();
            this.setCookie('userid', userid);
        } else {
            userid = this.getCookie('userid');
        }

        statistic.ref = window.location.host;

        const sid = this.getCookie('sid');

        statistic.sid = sid;

        if (typeof videoinfo !== 'undefined') {
            const categoryPath = videoinfo.categoryPath; // eslint-disable-line

            if (categoryPath) {
                info = `//v.ifeng.com/${categoryPath}/,,,`;
            } else {
                info = '//v.ifeng.com/,,,';
            }
        }
        statistic.ci = info;
        statistic.pt = 'vtype=player';
        statistic.time = new Date().getTime();
        statistic.uri = window.location.href;

        this.sendStatisticInfoM(statistic);

        return statistic;
    }
    sendStatisticInfoM(param) {
        const statisticUrl = '//stadig.ifeng.com/actsta.js';

        // eslint-disable-next-line
        $.ajax({
            url: statisticUrl,
            data: param,
            cache: true,
            dataType: 'script'
        });
    }
}

export default PCVideoutil;



// WEBPACK FOOTER //
// /Users/zhujian/Desktop/code/live_system/live/modules/f.component.util/app/lib/auth/utils/utilPc.js